import { useRecoilState } from 'recoil'
import { floatingButtonBarOpenAtom } from 'state/floating-button-bar-visibility'

function useFloatingButtonBarVisibility() {
  const [isFloatingButtonBarOpen, setIsFloatingButtonBarOpen] = useRecoilState<boolean>(floatingButtonBarOpenAtom)

  return {
    isFloatingButtonBarOpen,
    setIsFloatingButtonBarOpen,
  }
}

export { useFloatingButtonBarVisibility }
